<main>
  <caixa-webcomponent-navigation-bar />

  <header class="credit-card-summary-header">
    <caixa-webcomponent-main-title
      text="Resumo do Cartão"
    />
  </header>

  <section class="cds-card summary-section">
    <section class="summary-toolbar">
      <button
        type="button"
        class="cds-button c-foreground-500 s-hollow s-stretch"
        (click)="onReturn()"
      >
        Retornar
      </button>

      <p class="section-subtitle">
        Última atualização {{ lastUpdate() | date:'dd/MM/yyyy HH:mm:ss' }}
      </p>
    </section>
    @if (showHeader()) {
      <pcp-header-multiple-accounts-relationship
        (editClicked)="onEditProduct($event)"
      />
    }
  </section>

  <section class="cds-card summary-section invoices-section">
    <h3 class="invoices-title">Faturas do cartão</h3>
    @if (isLoadingInvoices()) {
      <div class="carousel-loading">
        @for (_ of [0, 1, 2, 3, 4, 5, 6, 7]; track $index) {
          <caixa-webcomponent-shimmer
            width="151px"
            height="160px"
            borderRadius="2px"
          />
        }
      </div>
    } @else if (invoices().length) {
      <pcp-invoice-list-carousel
        [items]="invoices()"
        [selectedItemTemplate]="card"
        (selectedInvoice)="onSelectedInvoice($event)"
      />
    } @else {
      <caixa-webcomponent-empty-state
        [message]="invoicesError()
          ? 'Não foi possível carregar as faturas.'
          : 'Nenhuma fatura encontrada'"
      />
    }
  </section>

  @if (selectedInvoice() !== null) {
    <section class="cds-card summary-section">
      <pcp-invoice-summary
        [title]="'Resumo da fatura selecionada'"
        [selectedInvoice]="selectedInvoice()!"
        [loading]="isLoadingInvoices()"
      />
    </section>
  }

  <section
    class="cds-card summary-section categories-section"
    (mouseenter)="trackCategoriesHover()"
  >
    <h2 class="categories-title">
      Gastos totais por categoria
    </h2>

    @if (categoriesLoading$ | async) {
      <cds-simple-bar-chart
        [barChartItems]="[]"
        [displayLegends]="false"
        [shouldSort]="false"
        [loading]="true"
      />
    } @else if ((legendItems$ | async)?.length) {
      <cds-simple-bar-chart
        [barChartItems]="(barItems$ | async) ?? []"
        [displayLegends]="false"
        [shouldSort]="false"
        [loading]="false"
      />

      <ul
        class="categories-legend"
        [style.--legend-rows]="legendRows$ | async"
      >
        @for (item of legendItems$ | async; track item.name) {
          <li class="categories-legend__item">
            <span
              class="categories-legend__slider"
              [style.background-color]="item.color"
            ></span>
            <span
              class="categories-legend__name"
            >
              {{ item.name }}
              @if (item.showInfo) {
                <button
                  type="button"
                  class="categories-legend__info"
                  [attr.aria-label]="uncategorizedTooltip"
                  [cdsTooltip]="uncategorizedTooltip"
                  [placement]="'top'"
                >i</button>
              }
            </span>
            <span class="categories-legend__dots"></span>
            <span class="categories-legend__values">
              {{ item.value | money }} | {{ item.percent | number:'1.0-1' }}%
            </span>
          </li>
        }
      </ul>
    } @else {
      <caixa-webcomponent-empty-state
        [message]="(categoriesError$ | async)
          ? 'Não foi possível carregar os gastos por categoria.'
          : 'Nenhum gasto por categoria encontrado'"
      />
    }
  </section>

  <caixa-webcomponent-transactions-table [billId]="selectedBillId()" />
</main>

<ng-template #card let-invoice>
  <div class="invoice-selected-card">
    <h6 class="invoice-label">{{ invoice.label }}</h6>
    <p class="invoice-amount">{{ invoice.value | money }}</p>
    <span
      class="invoice-status-text"
      [ngClass]="invoiceStatusColor(invoice.status)"
    >
      {{ invoiceStatusLabel.get(invoice.status) }}
    </span>
  </div>
</ng-template>
